export const DATA_OPERATOR_ORG_ID = '24130eb9-1daa-44ae-8be4-629dd66739fe';

export const FIELD_VISIBILITY_LABELS: Record<string, string> = {
  hidden: 'Hidden (data operator only)',
  public: 'Public (all companies)',
  company_public: 'Company only',
};
